import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';

export default function Gala2025Page() {
  const { locale, prefix } = useLanguage();
  const isZh = locale === 'zh';

  return (
    <div>
      {/* Hero */}
      <section
        style={{
          background: 'linear-gradient(135deg, #1a237e 0%, #283593 40%, #3949ab 100%)',
          color: '#fff',
          padding: '120px 0 80px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'radial-gradient(circle at 30% 40%, rgba(255,215,0,0.12) 0%, transparent 50%), radial-gradient(circle at 70% 60%, rgba(76,175,80,0.1) 0%, transparent 50%)',
          }}
        />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <span
            style={{
              display: 'inline-block',
              background: 'rgba(255,255,255,0.15)',
              backdropFilter: 'blur(8px)',
              borderRadius: 24,
              padding: '6px 20px',
              fontSize: '0.85rem',
              fontWeight: 600,
              marginBottom: 20,
              letterSpacing: 1,
            }}
          >
            {isZh ? '2025 蛇年' : '2025 YEAR OF THE SNAKE'}
          </span>
          <h1 style={{ fontSize: '3.5rem', fontWeight: 900, marginBottom: 12, lineHeight: 1.1 }}>
            {isZh ? '《盛宴》2025' : 'Festive Feast 2025'}
          </h1>
          <p style={{ fontSize: '1.5rem', fontWeight: 300, marginBottom: 8, opacity: 0.95 }}>
            {isZh ? '橙县华人蛇年春晚' : 'Year of the Snake Lunar New Year Gala'}
          </p>
          <p style={{ fontSize: '1.1rem', opacity: 0.85, maxWidth: 600, margin: '0 auto 32px' }}>
            {isZh
              ? 'Chinese-American Association of Orange County'
              : '橙县华人协会 (CAAOC)'}
          </p>
          <span
            className="badge"
            style={{
              background: 'rgba(255,255,255,0.2)',
              color: '#fff',
              fontSize: '0.9rem',
              padding: '8px 20px',
            }}
          >
            {isZh ? '已圆满结束' : 'Event Concluded'}
          </span>
        </div>
      </section>

      {/* Event Details */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 60, alignItems: 'start' }}>
            <div>
              <h2 className="section-title" style={{ marginBottom: 24 }}>
                {isZh ? '活动详情' : 'Event Details'}
              </h2>

              <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
                {[
                  {
                    icon: '\uD83D\uDCC5',
                    label: isZh ? '日期' : 'Date',
                    value: isZh ? '2025年1月12日 (星期日)' : 'Sunday, January 12, 2025',
                  },
                  {
                    icon: '\u23F0',
                    label: isZh ? '时间' : 'Time',
                    value: isZh
                      ? '5:30-7:00pm 嘉年华 | 7:00-9:30pm 演出'
                      : '5:30-7:00 PM Carnival | 7:00-9:30 PM Main Performance',
                  },
                  {
                    icon: '\uD83D\uDCCD',
                    label: isZh ? '地点' : 'Venue',
                    value: 'Irvine Barclay Theatre, 4242 Campus Dr, Irvine, CA 92612',
                  },
                  {
                    icon: '\uD83C\uDFAD',
                    label: isZh ? '主题' : 'Theme',
                    value: isZh ? '蛇年庆典 - 金蛇献瑞' : 'Year of the Snake Celebration',
                  },
                ].map((item) => (
                  <div
                    key={item.label}
                    style={{
                      display: 'flex',
                      gap: 16,
                      alignItems: 'flex-start',
                      padding: 16,
                      background: 'var(--gray-100)',
                      borderRadius: 'var(--radius-md)',
                    }}
                  >
                    <span style={{ fontSize: '1.5rem', flexShrink: 0 }}>{item.icon}</span>
                    <div>
                      <div style={{ fontWeight: 700, fontSize: '0.85rem', color: 'var(--gray-500)', textTransform: 'uppercase', letterSpacing: 0.5, marginBottom: 2 }}>
                        {item.label}
                      </div>
                      <div style={{ fontWeight: 600, color: 'var(--gray-800)', fontSize: '1rem' }}>
                        {item.value}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h2 className="section-title" style={{ marginBottom: 24 }}>
                {isZh ? '关于2025春晚' : 'About the 2025 Gala'}
              </h2>
              <div style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8 }}>
                <p style={{ marginBottom: 16 }}>
                  {isZh
                    ? '华人春晚，是每一个远离故土的华人心中最温暖的乡愁。每当春节的脚步临近，那些熟悉的旋律、欢乐的笑声、和亲人团聚的温馨画面，总会在心头涌起。对于生活在海外的华人来说，春晚不仅仅是一台文艺演出，更是连接故乡与异乡的一座桥梁。'
                    : 'The Chinese Spring Gala holds a special place in the hearts of Chinese-Americans living far from their homeland. As the Lunar New Year approaches, familiar melodies, joyful laughter, and warm memories of family gatherings fill our hearts. For overseas Chinese, the Spring Gala is more than a performance — it is a bridge connecting us to our roots.'}
                </p>
                <p style={{ marginBottom: 16 }}>
                  {isZh
                    ? '2025蛇年春晚在Irvine Barclay Theatre隆重举行，为橙县华人社区奉献了一场精彩绝伦的文化盛宴。从歌舞到器乐，从武术到诗朗诵，每一个节目都展现了华人社区的才华与热情。'
                    : 'The 2025 Year of the Snake Gala was held at the Irvine Barclay Theatre, delivering an extraordinary cultural feast for the Orange County Chinese-American community. From song and dance to instrumental performances, from martial arts to poetry recitation, every act showcased the talent and passion of our community.'}
                </p>
                <p>
                  {isZh
                    ? '感谢所有参与者、志愿者和赞助商的支持，让这场春晚成为难忘的美好记忆。'
                    : 'We thank all participants, volunteers, and sponsors whose support made this gala an unforgettable experience.'}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <h2 className="section-title">{isZh ? '演出视频' : 'Performance Video'}</h2>
            <p className="section-subtitle" style={{ margin: '0 auto' }}>
              {isZh ? '观看2025蛇年春晚精彩回放' : 'Watch the 2025 Year of the Snake Gala replay'}
            </p>
          </div>

          <div
            style={{
              maxWidth: 800,
              margin: '0 auto',
              background: 'var(--white)',
              borderRadius: 'var(--radius-lg)',
              overflow: 'hidden',
              boxShadow: 'var(--shadow-xl)',
            }}
          >
            <div
              style={{
                position: 'relative',
                paddingBottom: '56.25%',
                height: 0,
                background: '#000',
              }}
            >
              <iframe
                src="https://www.youtube.com/embed/videoseries?list=PLExample2025"
                title="Festive Feast 2025"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  border: 'none',
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Organization Story */}
      <section style={{ padding: 'var(--section-padding)', background: 'var(--white)' }}>
        <div className="container">
          <div style={{ maxWidth: 800, margin: '0 auto' }}>
            <h2 className="section-title" style={{ textAlign: 'center', marginBottom: 24 }}>
              {isZh ? '协会故事' : 'Our Story'}
            </h2>
            <div style={{ fontSize: '1.05rem', color: 'var(--gray-600)', lineHeight: 1.8, textAlign: 'center' }}>
              <p style={{ marginBottom: 16 }}>
                {isZh
                  ? '橙县华人协会自创立以来，经历了从小到大的发展历程。从最初的社区联谊活动，到如今一年一度的大型春晚演出，协会凝聚了无数热心志愿者的辛勤付出和社区成员的鼎力支持。'
                  : 'Since its establishment, CAAOC has grown from humble beginnings to become a pillar of the community. From early social gatherings to the grand annual Gala performances of today, the association has been built on the dedication of countless volunteers and the unwavering support of community members.'}
              </p>
              <p>
                {isZh
                  ? '《盛宴》春晚不仅是一场演出，更是橙县华人社区团结和传承的象征。我们将继续为社区带来更多精彩活动。'
                  : 'The Festive Feast Gala is more than a show — it is a symbol of unity and cultural preservation for the Orange County Chinese-American community. We will continue to bring more wonderful events to our community.'}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation to other galas */}
      <section style={{ padding: '48px 0 64px', background: 'var(--gray-100)' }}>
        <div className="container">
          <div style={{ display: 'flex', justifyContent: 'center', gap: 16, flexWrap: 'wrap' }}>
            <Link to={prefix + '/gala'} className="btn btn-primary" style={{ padding: '12px 28px' }}>
              {isZh ? '《盛宴》2026' : 'Festive Feast 2026'}
            </Link>
            <Link to={prefix + '/gala/2024'} className="btn btn-outline" style={{ padding: '12px 28px' }}>
              {isZh ? '《盛宴》2024' : 'Festive Feast 2024'}
            </Link>
          </div>
        </div>
      </section>

      <style>{`
        @media (max-width: 768px) {
          .section-title { font-size: 1.8rem !important; }
        }
      `}</style>
    </div>
  );
}
